import xo from "../Assets/XO.png";
import puzzle from "../Assets/puzzle.png";
import chess from "../Assets/chess.png";
import ludo from "../Assets/ludo.png";
import snake from "../Assets/snake.png";
import universe from "../Assets/universe.png";
export const games = [
  {
    alt: "puzzles",
    uri: puzzle,
    delay: 800,
  },
  {
    alt: "Tic-Tac-Toe",
    uri: xo,
    delay: 1100,
  },

  {
    alt: "snake",
    uri: snake,
    delay: 1500,
  },
  {
    alt: "universe",
    uri: universe,
    delay: 1900,
  },
  {
    alt: "chess",
    uri: chess,
    delay: 2200,
  },
  {
    alt: "ludo",
    uri: ludo,
    delay: 2400,
  },
];
